var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFolder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.8679 69.878H115.024C119.369 69.878 123.375 67.5293 125.496 63.7375L138.14 41.1406C140.262 37.3487 144.267 35 148.612 35H172C178.627 35 184 40.3726 184 47V153C184 159.627 178.627 165 172 165H28C21.3726 165 16 159.627 16 153V95.2439",
    stroke: "#1B1B1B",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.122 71.8778V99.9998H48.122V71.8778H76.2439V67.8778H48.122V39.7559H44.122V67.8778H16V71.8778H44.122Z",
    fill: "#59BD39"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export default ForwardRef;